import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpShop'

export const creatorProductList = (params = '') => Http.get(`/creator-products${serialize(params)}`)
export const creatorProductCreate = data => Http.post('/creator-products', data)
export const creatorProductUpdate = (id, data) => Http.put(`/creator-products/${id}`, data)
export const creatorProductDestroy = id => Http.delete(`/creator-products/${id}`)
export const creatorStoreList = (params = '') => Http.get(`/creator-stores${serialize(params)}`)
